import React from 'react';
import PropTypes from 'prop-types';
import qs from "qs";
import { withRouter } from 'react-router-dom';
import bindAll from 'lodash.bindall';
import styles from './project-item.css';
import zan from './dianzan.png';
import eye from './eye.png';
import command from './pinglun.png';
import pintu from './pintu.png';
import { deleteShareProject } from '../../api/project';
import { deleteClazzCourse } from '../../api/clazz-course';
import { putTopClazz, cancelTopClazz } from '../../api/clazz';
import DeleteProject from '../modal/remove-modal';
import ModalManager from '../modal/modal-manager';
import message from '../message/message';

class Project extends React.PureComponent {
    constructor(props) {
        super(props);
        bindAll(this, [
            'handleItemSelect',
            'removeProject',
            'handleRemove'
        ]);
        this.query = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
    }

    handleItemSelect(item) {
        this.props.history.push(item.linkUrl);
    }

    // 移除课程
    async removeCourse(item) {
        const params = { clazz_id: this.query.id, course_id: item.id }
        const res = await deleteClazzCourse(params)
        if (res) {
            this.props.onClose();
            ModalManager.pop();
            message.show(res)
        }
    }

    // 移除作品
    async removeProject(item) {
        const params = { clazz_id: this.query.id, id: item.id }
        const res = await deleteShareProject(params)
        if (res) {
            this.props.onClose();
            ModalManager.pop();
            message.show(res)
        }
    }

    // 置顶课程
    async putTop(item) {
        const params = { clazz_id: Number(this.query.id), course_id: item.id }
        const res = await putTopClazz(params)
        if (res) {
            this.props.onClose();
            ModalManager.pop();
            message.show(res)
        }
    }

    // 取消置顶
    async cancelTop(item) {
        const params = { clazz_id: Number(this.query.id), course_id: item.id, rank: 0 }
        const res = await cancelTopClazz(params)
        if (res) {
            this.props.onClose();
            ModalManager.pop();
            message.show(res)
        }
    }

    // 移除课程
    handleRemove(e, type, item) {
        e.stopPropagation();
        ModalManager.open(DeleteProject, {
            title: type === 'courseEdit' ? '移除课程' : '移除作品',
            onClose: () => { },
            onSubmit: () => {
                if (type === 'courseEdit') {
                    this.removeCourse(item)
                } else {
                    this.removeProject(item)
                }
            },
            content: type === 'courseEdit' ? '确认要移除当前课程吗？' : '确认要移除当前作品吗？'
        })
    }

    //置顶课程
    operateClazz(e, item, type) {
        e.stopPropagation();
        ModalManager.open(DeleteProject, {
            title: type === 'top' ? '置顶课程' : '取消置顶',
            onClose: () => { },
            onSubmit: () => {
                if (type === 'top') {
                    this.putTop(item)
                } else {
                    this.cancelTop(item)
                }
            },
            content: type === 'top' ? '确认要置顶当前课程吗？' : '确认要取消置顶当前课程吗？'
        })
    }

    render() {
        const { data, share, allowDelete, top, onClick, itemNum, cardType, userShow, userInfo } = this.props;
        let errImg = 'http://oss.pkcode.cn/scratch/cover/course/default.png'
        if (cardType === 'course' || cardType === 'courseEdit') {
            errImg = 'http://oss.pkcode.cn/scratch/cover/course/default.png'
        } 
        else {
            errImg = 'http://oss.pkcode.cn/scratch/cover/lesson/default.png'
        }
        return (
            <React.Fragment>
                <div className={styles.itemBox}>
                    {data.length > 0 ? (
                        data.map((item, index) => (
                            <div
                                key={item.id}
                                className={`${styles.item} ${itemNum === 4 ? styles.item_4 : styles.item_3}`}
                                onClick={() => onClick ? onClick : this.handleItemSelect(item)}
                            >
                                <img className={styles.projectImg} src={item.imgUrl} onError={e => {e.target.onError = null;e.target.src=errImg}}></img>
                                <div className={styles.projectInfo}>
                                    <p title={item.name}>{item.name}</p>
                                    {
                                        share && (
                                            <div className={styles.shareData}>
                                                <div className={styles.shareItem}><img src={zan} /><span>{item.dataObj.like}</span></div>
                                                <div className={styles.shareItem}><img src={eye} /><span>{item.dataObj.view}</span></div>
                                                {/* <div className={styles.shareItem}><img src={command} /><span>{item.dataObj.share}</span></div> */}
                                            </div>
                                        )
                                    }
                                </div>
                                {
                                    (cardType === 'project' || cardType === 'courseEdit') &&
                                    <div className={styles.userContent}>
                                        <div>
                                            {
                                                userShow &&
                                                <div className={styles.user}>
                                                    <img src={window.config.staticURL + '/avatar/' + (userInfo.avatar || (item.dataObj.user && item.dataObj.user.avatar) || 'default.png')} />
                                                    <p>{userInfo.name || (item.dataObj.user && item.dataObj.user.name)}</p>
                                                </div>
                                            }
                                        </div>
                                        <div className={styles.operate}>
                                            {
                                                top ? (index === 0 ? (
                                                    <span className={styles.blue} onClick={e => this.operateClazz(e, item, 'down')}>取消置顶</span>
                                                ) : (
                                                    <span className={styles.blue} onClick={e => this.operateClazz(e, item, 'top')}>置顶</span>)
                                                ) : (
                                                    <span className={styles.blue}></span>
                                                )
                                            }
                                            {allowDelete && <span className={styles.gray} onClick={e => this.handleRemove(e, cardType, item)}>移除</span>}
                                        </div>
                                    </div>
                                }
                            </div>
                        ))
                    ) : (
                        <div className={styles.noContent}>
                            <img src={pintu} />
                            <span>虚位以待</span>
                        </div>
                    )}
                </div>
            </React.Fragment>
        );
    }
}

Project.propTypes = {
    allowDelete: PropTypes.bool,
    top: PropTypes.bool,
    data: PropTypes.arrayOf(PropTypes.object),
    onClick: PropTypes.func,
    share: PropTypes.bool,
    cardType: PropTypes.string,
    itemNum: PropTypes.number,
    userShow: PropTypes.bool,
    onClose: PropTypes.func,
    userInfo: PropTypes.object,
}

Project.defaultProps = {
    allowDelete: false,
    share: false,
    top: false,
    cardType: 'project',
    itemNum: 3,
    userShow: false,
    userInfo: {}
};

export default withRouter(Project);
